exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".saveprice[data-v-3cd45050] {\n  position: absolute;\n  border-radius: 28px;\n  border: 1px solid #990000;\n  color: #990000;\n  padding: 6px 11px;\n  top: -13px;\n  left: 0;\n  font-size: 14px;\n  z-index: 999;\n}", ""]);

// exports
